import PropTypes from 'prop-types';
import useAllProvidersBucket from '../../hooks/useAllProvidersBucket';
import UploadButtonGroup from '../common/UploadButtonGroup';
import FileList from '../common/FileList';
import useDropboxUploadHandler from '../../hooks/useDropboxUploadHandler';
import { reportSectionClasses, medicalProviderSectionHeadingClasses } from '../common/formClasses';

const AllProvidersBucket = ({ providerType }) => {
  const { isLoading, addBucketFilesFromArray, removeBucketFile, bucketFiles } = useAllProvidersBucket({ providerType });

  const { handleDropboxSuccess } = useDropboxUploadHandler({
    accept: 'application/pdf',
    onFilesReady: async (validFiles) => {
      await addBucketFilesFromArray(validFiles);
    }
  });

  return (
    <div className={`${reportSectionClasses} p-6 mb-6`}>
      <h4 className={medicalProviderSectionHeadingClasses}>Enter All Medical Records Here</h4>
      <FileList files={bucketFiles} onRemove={removeBucketFile} isLoading={isLoading} />
      <div className="row">
        <div className="col-md-12">
          <div className="flex justify-end">
            <UploadButtonGroup
              uploadButtonText="Upload Records"
              uploadButtonProps={{ isBorder: true }}
              accept="application/pdf"
              multiple={true}
              isLoading={isLoading}
              onFileSelect={(files) => addBucketFilesFromArray(files.file)}
              onDropboxSuccess={handleDropboxSuccess}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

AllProvidersBucket.propTypes = {
  providerType: PropTypes.string.isRequired,
};

export default AllProvidersBucket;
